import { useLocale } from '@e2m-customer-portal/hooks';
import { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export function AnnualDeviceTablePlaceholder(): ReactElement {
  const [t] = useTranslation();
  const { code: locale } = useLocale();

  return (
    <div className="w-full overflow-auto">
      <table className="w-full border-spacing-0 bg-white pb-14">
        <colgroup>
          <col width={`${300 / 17}%`} />
          <col width={`${200 / 17}%`} />
          <col width={`${200 / 17}%`} />
          <col width={`${200 / 17}%`} />
          <col width={`${200 / 17}%`} />
          <col width={`${200 / 17}%`} />
          <col width={`${200 / 17}%`} />
          <col width={`${200 / 17}%`} />
        </colgroup>
        <thead>
          <tr>
            <th
              rowSpan={2}
              className="box-border border-0 border-b border-solid border-divider p-5 text-end text-sm font-medium leading-4"
            >
              {t('SHARED_MONTH')}
            </th>
            <th
              rowSpan={2}
              className="box-border border-0 border-b border-l border-solid border-divider p-5 text-sm font-medium leading-4"
            >
              {t('ANNUAL_PLANNING_MAXIMUM')}
            </th>
            <th
              rowSpan={2}
              className="box-border border-0 border-b border-l border-solid border-divider p-5 text-sm font-medium leading-4"
            >
              {t('ANNUAL_PLANNING_MINIMUM')}
            </th>
            <th
              rowSpan={2}
              className="box-border border-0 border-b border-l border-solid border-divider p-5 text-sm font-medium leading-4"
            >
              {t('ANNUAL_PLANNING_AUXILIARY_CONSUMPTION')}
            </th>
            <th
              colSpan={4}
              className="box-border border-0 border-b border-l border-solid border-divider px-5 py-2 text-sm font-medium leading-4"
            >
              {t('ANNUAL_PLANNING_PRODUCTION')}
            </th>
          </tr>
          <tr>
            {[
              { startDay: new Date('1970-01-05T08:00'), endNight: new Date('1970-01-09T20:00') },
              { startDay: new Date('1970-01-03T08:00'), endNight: new Date('1970-01-04T20:00') },
            ].map(({ startDay, endNight }) => (
              <Fragment key={startDay.toISOString()}>
                <th className="box-border whitespace-pre border-0 border-b border-l border-solid border-divider px-5 py-4 text-sm font-medium leading-4">{`${startDay.toLocaleDateString(
                  locale,
                  {
                    weekday: 'short',
                  },
                )} - ${endNight.toLocaleDateString(locale, {
                  weekday: 'short',
                })}\n(${startDay.toLocaleTimeString(locale, {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })} - ${endNight.toLocaleTimeString(locale, {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })})`}</th>
                <th className="box-border whitespace-pre border-0 border-b border-l border-solid border-divider px-5 py-4 text-sm font-medium leading-4">{`${startDay.toLocaleDateString(
                  locale,
                  {
                    weekday: 'short',
                  },
                )} - ${endNight.toLocaleDateString(locale, {
                  weekday: 'short',
                })}\n(${endNight.toLocaleTimeString(locale, {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })} - ${startDay.toLocaleTimeString(locale, {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })})`}</th>
              </Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((row) => (
            <tr
              key={row}
              className="shadow-black/50 odd:bg-grey-50 first-of-type:shadow-[inset_0_2px_4px_-4px_var(--tw-shadow-color)]"
            >
              <th className="box-border border-0 border-b border-solid border-grey-200 p-5 text-end text-sm font-medium leading-4">
                <span className="lg:hidden">
                  {new Date(new Date('1970-01-01').setMonth(row)).toLocaleDateString(locale, {
                    month: 'short',
                  })}
                </span>
                <span className="hidden lg:inline">
                  {new Date(new Date('1970-01-01').setMonth(row)).toLocaleDateString(locale, {
                    month: 'long',
                  })}
                </span>
              </th>
              {[0, 1, 2, 3, 4, 5, 6].map((column) => (
                <td
                  key={column}
                  className="box-border border-0 border-b border-l border-solid border-grey-200 p-0 first-of-type:shadow-[inset_2px_0_4px_-4px_var(--tw-shadow-color)] first-of-type:shadow-black/50"
                >
                  <div className="flex h-4 items-center justify-center gap-2 p-[1.28125rem]">
                    <div className="animate-loading-1 aspect-square w-3 animate-pulse rounded-full bg-black/10" />
                    <div className="animate-loading-2 aspect-square w-3 animate-pulse rounded-full bg-black/10" />
                    <div className="animate-loading-3 aspect-square w-3 animate-pulse rounded-full bg-black/10" />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
